import { ITour } from './i-tour';
import {
  getBuiltInButtons,
  TourDeviceType,
  triggerCardActionsModalByState,
  triggerSideMenuDesktopByState,
  triggerSideMenuMobileByState
} from './default-step-options';
import shepherd from 'shepherd.js';
import { TranslateService } from '@ngx-translate/core';

// if at least one of predicates returns false then total result should false
function combinePredicates(predicates: (() => boolean)[]): () => boolean {
  return () => {
    debugger;
    return predicates.every(p => p());
  };
}

function checkStepDomElementExistence(step: shepherd.Step.StepOptions): () => boolean {
  return (): boolean => {
    let elOrSelector = typeof step.attachTo === 'string' ? step.attachTo : step.attachTo.element
    if (typeof elOrSelector === 'string') {
      elOrSelector = document.querySelector(elOrSelector) as HTMLElement;
    }
    if (!!elOrSelector) {
      console.log('el exists: ', step.attachTo)
    } else {
      console.log('el does not exist: ', step.attachTo)
    }
    return !!elOrSelector;
  }
}

function patchShowOnForSteps(steps: shepherd.Step.StepOptions[]): shepherd.Step.StepOptions[] {

  return steps.map(step => {
    return {
      ...step,
      showOn: step.showOn
        ? combinePredicates([step.showOn, checkStepDomElementExistence(step)])
        : checkStepDomElementExistence(step),
    } as shepherd.Step.StepOptions
  })
}

function patchLastStepButtons(steps: shepherd.Step.StepOptions[], buttons: ReturnType<typeof getBuiltInButtons>): shepherd.Step.StepOptions[] {
  const _steps = steps, lastStep = _steps[_steps.length - 1], restOfSteps = _steps.splice(0, _steps.length - 1);
  const lastStepBtns = [...lastStep.buttons];

  lastStepBtns.filter(b => b === buttons.next);
  if (!lastStepBtns.includes(buttons.cancel)) {
    lastStepBtns.push(buttons.cancel);
  }

  return [
    ...restOfSteps,
    {
      ...lastStep,
      buttons: lastStepBtns,
    }
  ]
}

const triggerProfilesCardsOrMap = () => {
  return ({platformRequiresToOpenCards, shouldOpen}) =>
    new Promise((resolve: (val?: unknown) => void) => {
      if (platformRequiresToOpenCards) {
        // if side menu is hidden
        const areCardsClosed =
          !document.querySelector(`#mainContainer.map-view`)?.classList?.contains('info-view');
        if (areCardsClosed === shouldOpen) {
          const el = document.querySelector('#switchView');
          (el as any)?.click();
          setTimeout(() => resolve(), 500);
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });

};

export const profilesSteps = (
  deviceType: TourDeviceType,
  translate: TranslateService
): shepherd.Step.StepOptions[] => {
  const mobileSearchContainerUsed = deviceType.deviceType === 'mobile' || deviceType.profilesSearchContainerType === 'mobile';
  const platformRequiresToOpenCardActionsModal = deviceType.deviceType === 'mobile';
  const onlyVerticalAlignment = deviceType.deviceType === 'mobile';
  const platformRequiresToOpenSideNav = deviceType.deviceType === 'mobile' || deviceType.profilesSearchContainerType === 'mobile';

  const hasVantageAssistant = !!document.querySelector('.assistant-fab-button');
  const t = (key: string) => translate.instant(key);
  const buttons = getBuiltInButtons(translate);

  const _preparations = (x: {
    shouldOpenCards: boolean;
    shouldOpenCardsMenu: boolean;
    shouldOpenSideNav: boolean; // open sidenav on mobile devices
    requiresScrollTop?: true;
  }) => Promise.all([
      triggerSideMenuMobileByState({platformRequiresToOpenSideNav, shouldOpenSideNav: x.shouldOpenSideNav})()
        .then(triggerSideMenuDesktopByState({shouldOpen: !platformRequiresToOpenSideNav})),
      triggerCardActionsModalByState({shouldOpenCardsMenu: x.shouldOpenCardsMenu, platformRequiresToOpenCardActionsModal})(),
      triggerProfilesCardsOrMap()({
        platformRequiresToOpenCards: mobileSearchContainerUsed,
        shouldOpen: x.shouldOpenCards
      })
    ]).then(async () => {
      if ('requiresScrollTop' in x) {
        const cardsScrollContainer = document.querySelector('.cards-wrapper');
        cardsScrollContainer.scrollTop = 0;
        await new Promise((resolve) => setTimeout(resolve, 300)); // 250ms is header animation
      }
    });

  return [
    {
      attachTo: {
        element: '#map',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: false,
          shouldOpenCardsMenu: false,
          shouldOpenSideNav: false,
          requiresScrollTop: true,
        }),
      scrollTo: false,
      popperOptions: {
        modal: false,
      },
      buttons: [buttons.next],
      id: 'defaultLandingScreen',
      title: t('onboarding.profiles.steps.defaultLandingScreen.title'),
      text: t('onboarding.profiles.steps.defaultLandingScreen.text'),
    } as shepherd.Step.StepOptions,
    {
      attachTo: {
        element: '#map',
      },
      beforeShowPromise: () =>
        _preparations({ shouldOpenCards: false, shouldOpenCardsMenu: false, shouldOpenSideNav: false, requiresScrollTop: true }),
      buttons: [buttons.back, buttons.next],
      id: 'navigateMap',
      title: t('onboarding.profiles.steps.navigateMap.title'),
      text: t('onboarding.profiles.steps.navigateMap.text'),
    } as shepherd.Step.StepOptions,
    {
      attachTo: {
        element: `#searchContainer${mobileSearchContainerUsed ? '.mobile-only' : '.desktop-only'}`,
        on: 'top',
      },
      beforeShowPromise: () => {
        const a = mobileSearchContainerUsed;
        return _preparations({ shouldOpenCards: false, shouldOpenCardsMenu: false, shouldOpenSideNav: false });
      },
      buttons: [buttons.back, buttons.next],
      highlightClass: 'visible',
      id: 'searchAvailableIndicators',
      title: t('onboarding.profiles.steps.searchIndicators.title'),
      text: t('onboarding.profiles.steps.searchIndicators.text'),
    } as shepherd.Step.StepOptions,

    {
      attachTo: {
        element:
          'div.ps-content > nav:nth-child(1) > ul.bottom-line-devider+ul > li:nth-child(1)',
        on: onlyVerticalAlignment ? 'bottom-start' : 'right-start',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: false,
          shouldOpenCardsMenu: false,
          shouldOpenSideNav: true,
        }),
      buttons: [buttons.back, buttons.next],
      id: 'informationDomains',
      title: t('onboarding.profiles.steps.informationDomains.title'),
      text: t('onboarding.profiles.steps.informationDomains.text'),
    } as shepherd.Step.StepOptions,

    {
      attachTo: {
        element:
          'div.ps-content > nav:nth-child(1) > ul.nav-title-wrapper > li:nth-child(1)',
        on: onlyVerticalAlignment ? 'bottom-start' : 'right-start',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: false,
          shouldOpenCardsMenu: false,
          shouldOpenSideNav: true,
        }),
      buttons: [buttons.back, buttons.next],
      id: 'multipleInformationDomains',
      title: t('onboarding.profiles.steps.multipleInformationDomains.title'),
      text: t('onboarding.profiles.steps.multipleInformationDomains.text'),
    } as shepherd.Step.StepOptions,

    {
      attachTo: {
        element: '.static-content-wrapper .nav-item.create-collection',
        on: 'top-start',
      },
      beforeShowPromise: () =>
        _preparations({ shouldOpenCards: false, shouldOpenCardsMenu: false, shouldOpenSideNav: true }),
      scrollTo: true,
      buttons: [buttons.back, buttons.next],
      highlightClass: 'hover-effect-btn',
      id: 'createCollection',
      title: t('onboarding.shared.createCollectionTitle'),
      text: t('onboarding.shared.createCollectionText'),
    } as shepherd.Step.StepOptions,

    {
      attachTo: {
        element: 'vantage-platform-card vantage-platform-question, vantage-platform-empty, vp-no-profiles-cards',
        on: 'top',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: true,
          shouldOpenCardsMenu: false,
          shouldOpenSideNav: false,
        }),
      scrollTo: mobileSearchContainerUsed,
      buttons: [buttons.back, buttons.next],
      id: 'insightCards',
      title: t('onboarding.profiles.steps.insightCards.title'),
      text: t('onboarding.profiles.steps.insightCards.text'),
    } as shepherd.Step.StepOptions,

    ...(platformRequiresToOpenCardActionsModal
      ? [
        {
          attachTo: {
            element: '.show-mobile-menu-btn',
            on: onlyVerticalAlignment ? 'bottom-end' : 'right-end',
          },
          beforeShowPromise: () =>
            _preparations({
              shouldOpenCards: true,
              shouldOpenCardsMenu: false,
              shouldOpenSideNav: false,
              requiresScrollTop: true,
            }),
          scrollTo: true,
          buttons: [buttons.back, buttons.next],
          highlightClass: 'hover-effect-icon-btn',
          id: 'cardActionsMenu',
          title: t('onboarding.shared.cardsMenuTitle'),
          text: t('onboarding.shared.cardsMenuText'),
        } as shepherd.Step.StepOptions,

        {
          attachTo: {
            element: 'vantage-platform-add-to-collection.mobile>button',
            on: onlyVerticalAlignment ? 'top-end' : 'right-end',
          },
          beforeShowPromise: () =>
            _preparations({
              shouldOpenCards: true,
              shouldOpenCardsMenu: true,
              shouldOpenSideNav: false,
            }),
          buttons: [buttons.back, buttons.next],
          highlightClass: 'hover-effect-icon-btn',
          id: 'addToCollection',
          title: t('onboarding.shared.addCardTitle'),
          text: t('onboarding.shared.addCardText'),
        } as shepherd.Step.StepOptions
      ]
      : [
        {
          attachTo: {
            element: 'vantage-platform-add-to-collection>button',
            on: onlyVerticalAlignment ? 'bottom-end' : 'right-end',
          },
          beforeShowPromise: () =>
            _preparations({
              shouldOpenCards: false,
              shouldOpenCardsMenu: false,
              shouldOpenSideNav: false,
            }),
          buttons: [buttons.back, buttons.next],
          highlightClass: 'hover-effect-icon-btn',
          id: 'addToCollection',
          title: t('onboarding.shared.addCardTitle'),
          text: t('onboarding.shared.addCardText'),
        } as shepherd.Step.StepOptions
      ]),

    {
      attachTo: {
        element: platformRequiresToOpenCardActionsModal
          ? 'button.bottom-sheet-menu-item.card-share-2-teams'
          : 'button.card-share-2-teams',
        on: 'bottom-end',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: true,
          shouldOpenCardsMenu: true,
          shouldOpenSideNav: false,
        }),
      buttons: [buttons.back, buttons.next],
      highlightClass: 'hover-effect-icon-btn',
      id: 'shareCard',
      title: t('onboarding.shared.shareCardTitle'),
      text: t('onboarding.shared.shareCardText'),
    } as shepherd.Step.StepOptions,

    {
      attachTo: {
        element:
          'vp-side-nav > div.side-menu > div.side-menu-header > button.text.menu-btn > span',
        on: onlyVerticalAlignment ? 'bottom' : 'left',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: false,
          shouldOpenSideNav: true,
          shouldOpenCardsMenu: false,
        }),
      buttons: [buttons.back, hasVantageAssistant ? buttons.next : buttons.cancel],
      highlightClass: 'hover-effect-btn',
      id: 'appsSelector',
      title: t('onboarding.shared.productSuiteTitle'),
      text: t('onboarding.shared.productSuiteText'),
    } as shepherd.Step.StepOptions,

    ...(hasVantageAssistant ? [{
      attachTo: {
        element: '.assistant-fab-button',
        on: onlyVerticalAlignment ? 'top' : 'right-end',
      },
      beforeShowPromise: () =>
        _preparations({
          shouldOpenCards: false,
          shouldOpenCardsMenu: false,
          shouldOpenSideNav: false
        }),
      buttons: [buttons.back, buttons.cancel],
      id: 'assistant',
      title: t('onboarding.shared.assistantTitle'),
      text: t('onboarding.shared.assistantText'),
    } as shepherd.Step.StepOptions] : []),
  ] as shepherd.Step.StepOptions[];
};

export const profilesTour = (deviceType: TourDeviceType, translate: TranslateService): ITour => {
  const t = (key: string) => translate.instant(key);
  const buttons = getBuiltInButtons(translate);
  return {
    welcomeMsg: t('onboarding.profiles.welcome'),
    tourDescription: t('onboarding.profiles.description'),
    path: 'profiles',
    icon: 'product_profiles',
    steps: patchLastStepButtons(patchShowOnForSteps(profilesSteps(deviceType, translate)), buttons),
  };
};
